import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FullCatalogPage = lazy(() => import('~/features/content-enrichment/pages/full-catalog-page'));

export const Route = createFileRoute(
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/full',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FullCatalogPage />
    </Suspense>
  ),
});
